import React, { useState } from "react";
import { Container, Typography, Tab } from "@mui/material";
import TabsMenu from "../../components/TabsMenu";
import { TabPanel } from "@mui/lab";
import HeaderHelpPage from "../../components/HeaderHelpPage";

// Components
import AllBankAccount from "./all";
import PendingBankAccount from "./pending";
import HistoryBankAccount from "./history";

const BankAccountPage = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const handleChange = (event, value) => {
    setSelectedView(value);
  };

  return (
    <Container>
      <HeaderHelpPage title="Bank Account" description="Allow Oxygen7 user to manage a bank account." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        <TabPanel value="All">
          <AllBankAccount userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingBankAccount userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryBankAccount userRole={userRole} />
        </TabPanel>
      </TabsMenu>
    </Container>
  );
};

export default BankAccountPage;